import { useCallback, useContext, useEffect, useState } from 'react';

import ArrowRightOutlined from '@ant-design/icons/ArrowRightOutlined';
import SaveOutlined from '@ant-design/icons/SaveOutlined';
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControlLabel, Grid, Link, Switch, TextField } from '@mui/material';
import { Button } from 'antd';
import { CustomButtonAntd } from 'components/Shared/CustomButtonAntd/style';
import { IEventForm } from 'interfaces/event';
import FormContext from 'Pages/Events/Context';
import { Controller, useFormContext } from 'react-hook-form';

import TextAdornment from '../../TextAdornment';
import * as S from './styles';

const FormFour = () => {
  const { handleEdit, isCreate, loadingEdit, jobsLotPending, setCurrentStep, setStepsEnables, stepsEnables } =
    useContext(FormContext);

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    control
  } = useFormContext<IEventForm>();

  const [activeReserveTime, setActiveReserveTime] = useState(false);

  const [activePreCheckout, setActivePreCheckout] = useState(false);

  const handleChangeActiveReserveTime = (event: React.ChangeEvent<HTMLInputElement>) => {
    setActiveReserveTime(event.target.checked);
    setValue('hasReserveTime', event.target.checked);
    const activeReserveTime = event.target.checked;
    if (!activeReserveTime && getValues('reserve_time') !== 0) {
      setValue('reserve_time', 0);
    }
    if (activeReserveTime && getValues('reserve_time') === 0) {
      setValue('reserve_time', 1);
    }
  };

  const handleChangeActivePreCheckout = (active: 0 | 1) => {
    if (active === 1) setActivePreCheckout(true);
    if (active === 0) setActivePreCheckout(false);
  };

  const handleNext = useCallback(() => {
    const enablesSteps = Array.from(stepsEnables);
    if (!enablesSteps.includes('5')) {
      enablesSteps.push('5');
      setStepsEnables(enablesSteps);
    }

    setCurrentStep('5');
  }, [stepsEnables, setCurrentStep, setStepsEnables]);

  useEffect(() => {
    if (getValues('active_precheckout') === 1) {
      setActivePreCheckout(true);
    }
    if (getValues('reserve_time') !== 0) {
      setActiveReserveTime(true);
    }
  }, []);

  return (
    <>
      <S.CustomGrid container spacing={4}>
        <S.CustomWrapper item xs={12} md={12}>
          <Controller
            control={control}
            name='active_precheckout'
            render={({ field: { onChange, value } }) => (
              <Switch
                onChange={event => {
                  const active = event.target.checked ? 1 : 0;
                  if (active) {
                    setActiveReserveTime(true);
                    setValue('reserve_time', 15);
                  }
                  handleChangeActivePreCheckout(active);
                  onChange(active);
                }}
                checked={!!value}
                value={value}
                id='switch-precheckout'
              />
            )}
          />
          <S.CustomLabel>Preenchimento de dados pré-checkout</S.CustomLabel>
        </S.CustomWrapper>
        <Grid item xs={12} md={12}>
          <S.CustomTypography>
            Ao ativar esta ferramenta, os compradores deverão fornecer os dados dos participantes antes de finalizar a
            compra. Para páginas de venda não fornecidas pela Blinket, você deve utilizar o
            <Link
              href='https://ajuda.eduzz.com/hc/pt-br/articles/4406141586971-Como-adicionar-o-Script-Widget-em-minha-p%C3%A1gina-de-vendas-Blinket'
              target='_blank'
              rel='noopener'
              sx={{ color: 'black' }}
              id='link-widget'
            >
              {' '}
              script widget
            </Link>
            .
          </S.CustomTypography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Link
            href='https://ajuda.eduzz.com/hc/pt-br/articles/7762902582299-Preenchimento-de-Dados-Pr%C3%A9-checkout'
            target='_blank'
            rel='noopener'
            sx={{ color: 'black' }}
            id='link-info'
          >
            Saiba mais
          </Link>
          <ArrowRightOutlined style={{ marginLeft: '5px' }} />
        </Grid>
      </S.CustomGrid>

      <S.CustomGrid container spacing={4}>
        <Grid item xs={4} md={4}>
          {!activePreCheckout && (
            <FormControlLabel
              control={
                <S.CustomSwitch
                  disabled={activePreCheckout}
                  checked={activeReserveTime}
                  onChange={handleChangeActiveReserveTime}
                />
              }
              label='Tempo de reserva de ingressos'
              sx={{ color: 'black' }}
              id='check-reserve-time'
            />
          )}
          {activePreCheckout && (
            <S.CustomReserveTimeLabelDisabled>Tempo de reserva de ingressos</S.CustomReserveTimeLabelDisabled>
          )}
        </Grid>
        <Grid item xs={8} md={8}>
          <TextField
            fullWidth
            disabled={!activeReserveTime || activePreCheckout}
            InputProps={{
              endAdornment: <TextAdornment>Minutos</TextAdornment>
            }}
            variant='outlined'
            type='number'
            helperText={errors.reserve_time?.message}
            error={!!errors.reserve_time}
            id='reserve_time-form-one'
            {...register('reserve_time')}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          {!activePreCheckout && (
            <S.CustomTypography>
              Desabilite esta funcionalidade se for vender seus ingressos em um lançamento, pois assim não haverá
              reserva de ingressos no checkout. Tempo máximo de 15 minutos.
            </S.CustomTypography>
          )}
          {activePreCheckout && (
            <S.CustomTypographyWhenPreCheckoutEnabled>
              O tempo de reserva é fixado em 15 minutos quando a opção "Preenchimento de dados pré-checkout" está
              habilitada, desabilite-a caso queira alterar o tempo de reserva.
            </S.CustomTypographyWhenPreCheckoutEnabled>
          )}
        </Grid>
      </S.CustomGrid>

      <Grid container justifyContent={isCreate ? 'space-between' : 'end'} item>
        {isCreate && (
          <Grid item>
            <CustomButtonAntd size='large' id='stepback-btn-form-4' onClick={() => setCurrentStep('3')}>
              Voltar
            </CustomButtonAntd>
          </Grid>
        )}
        <Grid item>
          {isCreate && (
            <Button
              onClick={() => {
                handleSubmit(handleNext)();
              }}
              type='primary'
              size='large'
              id='step-forward-btn-form-4'
            >
              Próximo
            </Button>
          )}

          {!isCreate && !loadingEdit && !jobsLotPending && (
            <Button
              onClick={() => {
                handleSubmit(handleEdit)();
              }}
              type='primary'
              size='large'
              id='save-btn-form-4'
            >
              <SaveOutlined style={{ color: '#00000' }} />
              Salvar
            </Button>
          )}

          {((!isCreate && loadingEdit) || !!jobsLotPending) && (
            <LoadingButton loading loadingIndicator='Salvando' startIcon={<SaveOutlined />} variant='outlined'>
              Salvando
            </LoadingButton>
          )}
        </Grid>

        {!!jobsLotPending && (
          <Grid container item justifyContent='flex-end' xs={12}>
            <div className='bottom-legend-button'>{jobsLotPending}</div>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default FormFour;
